import React, { useEffect } from 'react';
import AppHeader from '../components/AppHeader';
import BottomNav from '../components/BottomNav';
import DesktopSidebar from '../components/DesktopSidebar';

/**
 * AppShell — wraps any page with the sticky header and the post-login
 * bottom navigation bar (Home / Issues / Cases / Library / Profile).
 * Pages using MainLayout already get the header via MainLayout.
 * This wrapper is for pages that render their own layout (e.g., AskStewie, ConductPredictor).
 */
export default function AppShell({ children, showBackButton = true, user, onLogout, hideBottomNav = false }) {
  useEffect(() => {
    document.body.setAttribute('data-has-sidebar', 'true');
    return () => document.body.removeAttribute('data-has-sidebar');
  }, []);
  return (
    <>
      <DesktopSidebar user={user} />
      <AppHeader showBackButton={showBackButton} user={user} onLogout={onLogout} />
      <div style={{ paddingBottom: hideBottomNav ? 0 : 80 }}>
        {children}
      </div>
      {!hideBottomNav && <BottomNav />}
    </>
  );
}
